import { ContainerMessage } from './types'

type MessageHandler = {
  postMessage: (message: string) => void
}

declare global {
  interface Window {
    // Android webview only
    reservationToolMessenger?: MessageHandler

    // iOS Webview only
    webkit?: {
      messageHandlers?: {
        reservationTool?: MessageHandler
      }
    }

    dataLayer: unknown[]
  }
}

export const ContainerMessenger = {
  sendMessage: (messageObj: ContainerMessage) => {
    const message = JSON.stringify(messageObj)
    // For Android, we expect a root level message handler object to exist on the page called reservationToolMessenger
    // https://stackoverflow.com/a/69110392
    if (window.reservationToolMessenger) {
      window.reservationToolMessenger.postMessage(message)
    }

    // For iOS there will be a special webkit.messageHandlers object on the page that the app will attach a named
    // message handler onto.
    // https://stackoverflow.com/a/56692822
    if (window.webkit?.messageHandlers?.reservationTool) {
      window.webkit.messageHandlers.reservationTool.postMessage(message)
    }

    // For IFrames, we just use the standard window.parent API
    if (window.parent) {
      window.parent.postMessage(message, '*')
    }
  },
}
